import styled from 'styled-components'

export const StyledSearchBarWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 277px;
  width: 100%;
  background-image: url('/images/categories-bg.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
  margin-top: -40px;
  position: relative;
  z-index: 1;
  padding: 50px;

  h1 {
    color: var(--white);
    text-align: center;
    align-self: center;
  }

  @media only screen and (min-width: 577px) and (max-width: 768px) {
    flex-direction: column;
    padding: 24px;
    justify-content: start;
    background-image: url('/images/bg/nav-bg.png');
    .ant-btn-circle {
      background-color: transparent !important;
      border: none !important;
      .anticon {
        color: var(--cream);
        font-size: 34px;
      }
    }
  }

  @media only screen and (max-width: 576px) {
    flex-direction: row;
    padding: 24px;
    height: 172px;
    justify-content: center;
    background-image: url('/images/bg/nav-bg.png');
    .ant-btn-circle {
      background-color: transparent !important;
      border: none !important;
      .anticon {
        color: var(--cream);
        font-size: 34px;
      }
    }
  }
`
